define('views/shared/modal/modal_modern',[
	'backbone',
	'text!views/shared/modal/modal_modern.html',
	'views/_base/baseview',
], function (Backbone, Template, BaseView) {
	'use strict';

	return BaseView.extend({
		template: _.template(Template),
		tagName: 'div',
		id: 'pf-modal-modern',
		isRender: true,
		needsAuth: false,
		events: {
			'click #pf-modal-close-btn': 'closeMODAL',
		},
		initialize: function (options) {
			options = options || {};
			this.show = options.show;
			this.title = options.title;
			this.content = options.content;
			this.calling_view = options.calling_view;

			if (this.calling_view) {
				// If calling view's content is interactive, then inherit all of the events and properties from the view who called the Modal
				var inner_view_prop = {};
				for (var prop in this.calling_view) {
					if (prop.indexOf('MODAL') >= 0 || prop == 'events') {
						inner_view_prop[prop] = this.calling_view[prop];
					}
				}
				_.extend(this, inner_view_prop);
			}
			BaseView.prototype.initialize(this);
		},
		render: function () {
			var that = this;

			this.$el
				.html(this.template())
				.addClass(isSunsetting() ? 'termination-modal' : '');

			// Only show the modal if directed to do so
			if (this.show) {
				$('body').append(this.$el.fadeIn());
			}

			// This allows the html to render
			setTimeout(function () {
				that.$el.find('#pf-modal-close-btn').on('click', function () {
					that.closeMODAL();
				});
			}, 700);
		},
		closeMODAL: function () {
			var that = this;

			this.$el.fadeOut(function () {
				that.remove();
			});
		},
	});
});

